// Hard guard for the redesigned homepage (home-v2): it NEVER renders on production,
// whatever the newHomepageEnabled setting says. Production is recognised two ways:
//   1. the request host is a production host (www.besthandapp.com / besthandapp.com);
//   2. the server's own SITE_URL is a production host (covers raw-IP or other Host
//      headers reaching the prod droplet, whose nginx is the default_server).
// Shared by server.js (Host header + config.siteUrl) and client.js (window.location.hostname)
// so both sides agree. Removing a host from this list is the explicit go-live step for prod.
const PROD_HOSTS = new Set(['www.besthandapp.com', 'besthandapp.com']);

export function isProdHost(host) {
  const hostname = String(host || '').toLowerCase().split(':')[0].replace(/\.$/, '');
  return PROD_HOSTS.has(hostname);
}

const hostOfUrl = (url) => String(url || '').replace(/^[a-z]+:\/\//i, '').split('/')[0];

// Final decision: setting ON, request host not production, and this server not production.
export function shouldRenderNewHomepage(settingEnabled, host, siteUrl) {
  return settingEnabled === true && !isProdHost(host) && !isProdHost(hostOfUrl(siteUrl));
}

export default shouldRenderNewHomepage;
